import { JSONWidgetType as TeaserStandardVerticalJSONWidgetType } from '@widgets/TeaserStandardVertical'

import {
  ExecuteQuery,
  getAureusBatchRecommendations,
  getSectionWithAureusEnvironment,
  QueryFactory,
} from '..'

interface AureusBlickPlusCarouselItem extends Record<string, unknown> {
  aureusOfferId: string
  articleID: string
  teasers: {
    standardVertical: TeaserStandardVerticalJSONWidgetType
  }
}

export const queryKey = 'polaris-plus-content'

export const createQuery = (({
  sectionName = 'home',
}: {
  sectionName: 'home' | 'sport'
}) =>
  ({
    [queryKey]: {
      resultsLimit: 3,
      context: {
        section: getSectionWithAureusEnvironment(
          `polaris-${sectionName}-plus-content`,
        ),
        purpose: 'reference',
      },
    },
  }) as const) satisfies QueryFactory<typeof queryKey>

export const executeQuery = (async (
  queryOptions: Parameters<typeof createQuery>[0],
  options?: Record<string, unknown>,
) => {
  try {
    const result = (
      await getAureusBatchRecommendations<
        typeof queryKey,
        AureusBlickPlusCarouselItem
      >(createQuery(queryOptions), options)
    ).results[queryKey]

    if (!Array.isArray(result?.recommendations)) {
      return
    }

    return result.recommendations
  } catch (err) {
    console.error(err)
  }
}) satisfies ExecuteQuery<typeof queryKey>
